import _createClass from "/home/node/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/node/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/home/node/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/node/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Util } from './Util.js';
import { Layer } from './Layer.js';
import { _registerNode } from './Global.js';
export var FastLayer = /*#__PURE__*/function (_Layer) {
  _inherits(FastLayer, _Layer);
  var _super = _createSuper(FastLayer);
  function FastLayer(attrs) {
    var _this;
    _classCallCheck(this, FastLayer);
    _this = _super.call(this, attrs);
    _this.listening(false);
    Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    return _this;
  }
  return _createClass(FastLayer);
}(Layer);
FastLayer.prototype.nodeType = 'FastLayer';
_registerNode(FastLayer);